import { clearAllLoaders } from '@/redux/slices/common';
import { useEffect } from 'react';
import { useDispatch } from 'react-redux';
const PrivacyPolicy = () => {
  const dispatch = useDispatch();
  useEffect(() => {
    dispatch(clearAllLoaders());
  }, []);
  return <div className="terms-conditions" data-sentry-component="PrivacyPolicy" data-sentry-source-file="privacyPolicy.jsx">
            <div className="container pt-2 pb-6">
                <div className="terms-conditions-wrapper">
                    <div className="terms-conditions-txt">
                        <h3>Privacy Policy</h3>
                        <p>Thank you for being a Chicking Customer.</p>
                        <p>
                            At Chicking, we strive to do everything we can to respect the trust customers have in our
                            brand, and our commitment to your privacy is no exception. We are committed to protecting
                            and safeguarding consumer’s privacy on the internet.
                        </p>
                        <h4>Chicking Internet Privacy Policy</h4>
                        <p>
                            Chicking is pleased to provide information to all of its customers about its online Privacy
                            Policy. Please be assured that Chicking uses its best efforts to protect the privacy of
                            Chicking Mobile App Users.
                        </p>
                        <p>
                            This Privacy Policy (“Policy”) describes the types of personal information we collect from
                            visitors to our website and users of our Mobile Applications (collectively “Online
                            Services”). This Policy not only sets forth how we use this information, but also provides
                            other details about our personal information practices, and explains how to contact us if
                            you have any questions or concerns.
                        </p>
                        <h4>Types of Information we collect and how it is used</h4>
                        <p>
                            When using Online Services i.e. when ordering or registering on Chicking’s website or Mobile
                            Applications, you may be asked to enter your name, email address, mailing address, telephone
                            number or other details. Chicking gathers such personal information only when voluntarily
                            submitted by you. e.g., personal information may be collected from you in order to get your
                            feedback on our website and our products, or to improve our website in order to serve you
                            better, or to quickly process your transactions, or to ensure your entry in one of our
                            contests or sweepstakes. If you do not agree or consent to submission of such information,
                            you will not be allowed to register yourself or participate in our contests, sweepstakes or
                            use any functions on our website which require such personal information to be submitted.
                        </p>
                        <h4>Sharing of Personal Information</h4>
                        <p>
                            Chicking may share personal information within the Chicking Family. The Chicking Family
                            includes our parent company, our franchisees, our subsidiaries and our affiliates, of
                            course, any use of this information by the Chicking Family will comply with this Policy.
                            Occasionally, we will send marketing information to you, such as discount coupons,
                            information about new product offerings, etc. If you elect not to receive such materials, we
                            will not send them to you.
                        </p>
                        <p>
                            In addition, when you visit our website or use Online Services, we may collect certain
                            information by automated means. The information we collect may include your Internet
                            Protocol (IP) address, computer/mobile device operating system and browser type, type of
                            mobile device, the location of mobile device, the Unique Device Identifier (UDID) or Mobile
                            Equipment Identifier (MEID), the network carrier or any other information about your mobile
                            device, the address of a referring website (if any), and the pages you visit on our website.
                            We may use this information to operate, maintain, and manage our Online Services and to
                            provide services such as technical support. We provide additional information regarding our
                            use of “cookies” in this Privacy Policy below.
                        </p>
                        <h4>Card details</h4>
                        <p>Chicking does not store any of your debit or credit card details.</p>
                        <h4>How do we share personal information?</h4>
                        <p>
                            We may share personal information with the third parties to the extent reasonably necessary
                            to protect the security or integrity of our Online Services, take precautions against
                            liability, or respond to judicial process or requests from other governmental authorities;
                            or when we believe disclosure is necessary or appropriate to prevent physical harm or
                            financial loss, or in connection with an investigation of suspected or actual illegal
                            activity.
                        </p>
                        <p>
                            We also may share personal information collected by us with vendors that perform services
                            for Chicking. These services may include hosting our website, providing technical services
                            to Chicking, fulfilling requests or administering activities.
                        </p>
                        <h4>Access</h4>
                        <p>
                            You are in control of any personal information you provide us on-line. If at any time, you
                            would like to correct the personal information we have about you or if you would like to
                            change your preferences for contacts from us or on behalf of our business partners, you can
                            let us know by contacting us at the email or postal address listed below.
                        </p>
                        <h4>Cookies</h4>
                        <p>
                            “Cookies” are pieces of information that a website transfers to an individual’s hard drive
                            for record keeping purposes. Cookies allow the website to remember important information
                            that will make your use of the sites more convenient. Like most websites, Chicking uses
                            cookies for a variety of purposes in order to improve your on-line experience. e.g., we
                            track the total number of visitors to our website on an anonymous aggregate basis. We may
                            also employ cookies so that we remember you when you return to the sites, to keep track of
                            the items/pages you view on our website to help us customize your experience.
                        </p>
                        <p>We may associate personal information with a cookie file in those instances.</p>
                        <h4>Links to the other sites</h4>
                        <p>
                            In all cases, however, we will honour the commitments to our customers set forth in this
                            policy regarding the collection and use of personal information.
                        </p>
                        <h4>Changes to our Privacy Policy</h4>
                        <p>
                            If we change our Policy, we will post the revised version here, so we suggest that you check
                            here periodically for the most up-to-date version of our Policy. Your continued use of the
                            sites will be deemed acceptance of the Policy. Rest assured, however, that any changes will
                            not be retroactively applied and will not alter how we handle previously collected
                            information.
                        </p>
                        <h4>How to Contact Us?</h4>
                        <p>
                            If you have any questions about Chicking’s Internet Privacy Policy, please contact us at:
                            <br></br>
                            Email: <a href="mailto:contactus@chickinguae.com">contactus@chickinguae.com</a>
                            <br></br>
                            skype: chickinguae<br></br>
                            Telephone: 00971 4 2594808 <br></br>
                            Web:{' '}
                            <a href="https://www.chickinguae.com" target="_blank" rel="noopener noreferrer">
                                https://www.chickinguae.com
                            </a>
                        </p>
                        <p>Contact Address:</p>
                        <p>
                            #1106, ETA STAR, Al Manara Tower, PO Box: 87546, <br></br>
                            Al Abraj Street, Business Bay,Za&#39;abeel, Dubai, UAE.
                        </p>
                    </div>
                </div>
            </div>
        </div>;
};
export default PrivacyPolicy;